import React from "react"

export interface DynamicHeaderProps {
  brandComponent?: React.ReactNode
  topRightComponents?: React.ReactNode[] // key needs to be included in these components
  topRightItemAlignment?: "start" | "center" | "end"
  topRightXSpacing?: string
  menuComponent?: React.ReactNode
  menuComponentVisible?: boolean
  bottomRightComponent?: React.ReactNode // key needs to be included in these components
  bottomLeftComponent?: React.ReactNode // key needs to be included in these components
  ariaLabel?: string
}

export const DynamicHeader: React.FC<DynamicHeaderProps> = ({
  brandComponent,
  topRightComponents,
  topRightItemAlignment = "end",
  topRightXSpacing = "2",
  menuComponent,
  menuComponentVisible = true,
  bottomRightComponent,
  bottomLeftComponent,
  ariaLabel = "Page header",
}) => {
  const hasTopRightComponents = menuComponent || topRightComponents
  const hasTopRow = brandComponent || hasTopRightComponents
  const hasBottomRow = bottomLeftComponent || bottomRightComponent
  const topRightXSpacingStyle = `space-x-${topRightXSpacing}`
  const topRightItemAlignmentStyle = `items-${topRightItemAlignment}`

  return (
    <header
      aria-label={ariaLabel}
      className="flex flex-col w-full shadow-dark py-3 pl-4 box-border bg-white"
    >
      {/* top row */}
      <div className={`${hasTopRow ? "flex flex-row w-full" : "hidden"}`}>
        {/* top row - left - branding */}
        {brandComponent && (
          <div className="justify-start items-center flex w-1/2">
            {brandComponent}
          </div>
        )}
        {/* top row - right - menu + extra clickables */}
        <div
          className={`${menuComponent || topRightComponents ? "flex flex-row space-x-2 pr-3 justify-end w-1/2" : "hidden"}`}
        >
          <div
            className={`h-full md:flex md:flex-row md:${topRightXSpacingStyle} ${topRightItemAlignmentStyle}`}
          >
            {topRightComponents?.map((component) => component)}
          </div>
          {menuComponent && (
            <div
              className={`${menuComponentVisible ? "flex items-center md:items-end" : "hidden"}`}
            >
              {menuComponent}
            </div>
          )}
        </div>
      </div>

      {/* bottom row */}
      <div
        className={`${hasBottomRow ? "flex flex-col md:flex-row w-full" : "hidden"}`}
      >
        {/* bottom row - left */}
        <div
          className={`${bottomLeftComponent ? "flex justify-start items-center w-full md:w-1/2" : "hidden"}`}
        >
          {bottomLeftComponent && bottomLeftComponent}
        </div>
        {/* bottom row - right */}
        <div
          className={`${bottomRightComponent ? "flex justify-end items-center w-full md:w-1/2" : "hidden"}`}
        >
          {bottomRightComponent && bottomRightComponent}
        </div>
      </div>
    </header>
  )
}
